<template>
  <div class="alarm">
    <transition name="background">
      <div
        class="background"
        v-if="showAlarm || showCalendar || showDetail"
      ></div>
    </transition>
    <transition name="modal">
      <div
        v-if="showAlarm"
        class="popup"
      >
        <div class="wrapper">
          <p class="date">{{ fullDate }}</p>
          <h3 class="title">Wekker</h3>
          <p class="time">07:45</p>
          <button
            @click="buttonClick"
            class="button"
          >
            Stop
          </button>
        </div>
      </div>
    </transition>
    <transition name="modal">
      <Calendar
        @close="hideAlarm()"
        @day="showDetailFn()"
        v-if="showCalendar"></Calendar>
    </transition>
    <transition name="modal">
      <DayDetail
        @close="hideAlarm()"
        v-if="showDetail"></DayDetail>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import { scrollPositionMixin } from '@/mixins'
import Calendar from './Calendar'
import DayDetail from './DayDetail'
import { trackAlarm } from '@/utils/track'

export default {
  name: 'Alarm',
  data () {
    return {
      done: false,
      showAlarm: false,
      showCalendar: false,
      showDetail: false
    }
  },
  mixins: [scrollPositionMixin],
  components: {
    Calendar,
    DayDetail
  },
  watch: {
    reached () {
      if (!this.done) {
        this.showAlarm = true
        document.body.style.overflow = 'hidden'
        this.done = true
      }
    }
  },
  methods: {
    showCalendarFn () {
      this.showAlarm = false
      this.showCalendar = true
    },
    showDetailFn () {
      this.showCalendar = false
      this.showDetail = true
    },
    hideAlarm () {
      this.showAlarm = false
      this.showCalendar = false
      this.showDetail = false
      document.body.style.overflow = 'auto'
    },
    buttonClick () {
      trackAlarm('alarm-stop-clicked')
      this.showCalendarFn()
    }
  },
  computed: {
    fullDate () {
      return moment().locale('nl').format('dddd D MMMM')
    }
  }
}
</script>

<style lang="scss" scoped>
.alarm {
  transition: all .3s ease;
  position: relative;
  z-index: 200;
  text-align: center;
}
.background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba($c-dark, 0.96);
  z-index: 90;
  transition: all .3s ease;
}
.popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  transition: all .3s ease;
  z-index: 100;
}
.wrapper {
  width: 100%;
}
.date {
  font-size: 20px;
  line-height: 2.7;
  margin-bottom: 25px;

  &:first-letter {
    text-transform: uppercase;
  }
}
.title {
  font-size: 32px;
  line-height: 1.69;
}
.time {
  font-size: 60px;
  margin-bottom: 56px;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba($c-red, 0.4);
  }
  70% {
    box-shadow: 0 0 0 15px rgba($c-red, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($c-red, 0);
  }
}

.button {
  background-color: $c-red;
  box-shadow: 0 0 0 rgba($c-red, 0.4);
  animation: pulse 2s infinite;
  font-size: 20px;
  border-radius: 27.5px;
  height: 55px;
  min-width: 226px;
  color: white;
  border: none;
  padding: 0;
  line-height: 1;
  cursor: pointer;
  padding: 14px 15px 16px 15px;
  outline: 0;
}
.stop {
  font-size: 20px;
  line-height: 2.7;
  margin-top: 88px;
  cursor: pointer;
}
.background-enter {
  opacity: 0;
}
.background-leave-active {
  opacity: 0;
}
.modal-enter {
  opacity: 0;
  transform: translateY(25px);
}
.modal-leave-active {
  opacity: 0;
  transform: translateY(25px);
}
</style>



// WEBPACK FOOTER //
// src/components/alarm/Alarm.vue